module.exports = __webpack_public_path__ + "media/images/favicon/favicon-96x96-7d9995e433986b52af781d5a2329110f.png";